import React from 'react';
import Modal from 'react-modal';
import { LoadingSpinner } from '../LoadingSpinner';

import styles from './index.module.css';

interface Props extends Modal.Props {}

const LoadingModal: React.FC<Props> = (props) => {
  return (
    <Modal
      appElement={document.getElementById('root') ?? undefined}
      className={styles.ModalBody}
      overlayClassName={styles.Overlay}
      shouldCloseOnOverlayClick={false}
      {...props}
    >
      <LoadingSpinner />
    </Modal>
  );
};

export default LoadingModal;
